import { useParams } from 'react-router-dom';

function useNumberParams(defValue = 0, float = false): { [key: PropertyKey]: number } {
    const params = useParams<Record<string, string>>();

    return new Proxy(
        {},
        {
            get: (target, property: string) => {
                const paramValue = params[property];
                const result = float ? parseFloat(paramValue) : parseInt(paramValue);

                return Number.isNaN(result) ? defValue : result;
            },
        }
    );
}

export default useNumberParams;
